import React, { useEffect, useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import CameraView from './CameraView'
import CameraViewError from './CameraViewError'
import RecommendationView from './RecommendationView'
import { isMobile } from 'react-device-detect';

const useStyles = createUseStyles(theme => ({
  root: {
    height: '100%',
    flexDirection: 'column',
    flex: 1
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflowY: 'hidden'
  },
  cameraButton: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',

    border: `2px dashed ${theme.colors.primary}`,
    boxSizing: 'border-box',
    borderRadius: '8px',
    margin: '32px 36px',
    padding: '0 32px',
    cursor: 'pointer'
  },
  cameraText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    textAlign: 'center',
    marginTop: '20px',
    color: theme.colors.primary
  },
  image: {
    maxWidth: '80%',
    maxHeight: '70%'
  },
  tryAgain: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    textDecorationLine: 'underline', 
    color: theme.colors.secondary,
    margin: '24px 0'
  }
}))

function PictureStep (props) {
  
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ cameraStep, setCameraStep ] = useState(null)
  const [ mediaStream, setMediaStream ] = useState(null)
  const [ cameraImage, setCameraImage ] = useState(props.initialData ? props.initialData.image : null)

  useEffect(() => {
    return () => {
      if (mediaStream) {
        mediaStream.getTracks().forEach(track => track.stop())
      }
    }
  }, [ mediaStream ])

  const cancelPhoto = () => {
    if (mediaStream) {
        mediaStream.getTracks().forEach(track => track.stop())
    }
    setCameraStep(null)
    setMediaStream(null)
  }

  const goBack = () => {
    props.back()
  }

  const loadCameraView = async () => {
  
    const options = {
      audio: false
    };
  
    if(isMobile){
      options.video = true;
    } else {
      options.video = {
        width: { min: 640, ideal: 1280, max: 1280 },
        height: { min: 480, ideal: 720, max: 720 }
      }
    }

    try {
        const mediaStream = await navigator.mediaDevices.getUserMedia(options)
        setMediaStream(mediaStream)
        setCameraStep('cameraView')
    } catch(e){
        console.error("Erro ao tentar abrir a câmera, verifique se a câmera está ativa ou está com problemas.", e)
        setMediaStream(null)
        setCameraStep('cameraViewError')
    }   
  
  }

  const onCameraImage = image => {
    props.next({ image })
  }

  if (cameraStep === 'cameraView') {
    return (
      <CameraView
        title={props.msg}
        mediaStream={mediaStream}
        onCancel={cancelPhoto}
        onCameraImage={onCameraImage}
        index={props.index} 
        numOfSteps={props.numOfSteps}
        isMobile={isMobile}
      />
    ) 
  }

  if (cameraStep === 'cameraViewError') {
    return (
      <CameraViewError
        title={props.msg}
        onCancel={cancelPhoto}
        onNext={onCameraImage}
        index={props.index} 
        numOfSteps={props.numOfSteps}
      />
    ) 
  }

  return (
    <RecommendationView 
      index={props.index} 
      numOfSteps={props.numOfSteps}
      next={() => loadCameraView()}
      back={() => goBack()}
    />
  )
}

export default PictureStep